import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from '../button/button.module';
import { SearchModule } from '../search/search.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { SortableModule } from '../sortable/sortable.module';
import { CollapseModule } from '../collapse/collapse.module';
import { PaginationModule } from '../pagination/pagination.module';
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { IconModule } from '../icon/icon.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { FormModule } from '../form/form.module';
import { TableModule } from '../table/table.module';
import { ScrollModule } from '../scroll/scroll.module';
import { AppModalModule } from '../modal/modal.module';
import { HintsModule } from '../hints/hints.module';
import { StatusFieldModule } from '../status-field/status-field.module';
import { LoaderModule } from '../loader/loader.module';
import { AppTooltipModule } from '../tooltip/tooltip.module';
import { ImageRendererModule } from '../image-renderer/image-renderer.module';
import { FitmentsContextualActionModule } from './contextual-actions/fitments-contextual-action.module';
import { DetailsPageModule } from 'shared/details-page/details-page.module';

import { FitmentsAdvancedSearchComponent } from './fitments-advanced-search/fitments-advanced-search.component';
import { FitmentListManagerComponent } from './fitments-list-manager.component';
import { FitmentsTableComponent } from './fitments-table/fitments-table.component';
import { FitmentsSearchResultsComponent } from './search/search-results/fitments-search-results.component';
import { FitmentsTextRendererComponent } from './search/text-renderer/fitments-text-renderer.component';
import { FitmentsSortingPanelComponent } from './search/sorting-panel/fitments-sorting-panel.component';
import { FitmentsSearchPageComponent } from './fitments-search-page.component';
import { DefaultResearchInfograficComponent } from './default-research-infografic/default-research-infografic.component';
import { CellWidthDirective } from './search/cell-width.directive';
import { CellEditFormComponent } from './search/cell-edit-form/cell-edit-form.component';


import { FitmentsListService } from './fitments-list.service';
import { FitmentsService } from './fitments.service';
import { MyFitmentsSearchService } from './search/my-fitments-search.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    SearchModule,
    SpinnerModule,
    SortableModule,
    CollapseModule,
    PaginationModule,
    EmptyStateModule,
    IconModule,
    DropdownModule,
    FormModule,
    TableModule,
    ScrollModule,
    AppModalModule,
    HintsModule,
    StatusFieldModule,
    LoaderModule,
    AppTooltipModule,
    ImageRendererModule,
    FitmentsContextualActionModule,
    DetailsPageModule,
  ],
  declarations: [
    FitmentsAdvancedSearchComponent,
    FitmentListManagerComponent,
    FitmentsTableComponent,
    FitmentsSearchResultsComponent,
    FitmentsTextRendererComponent,
    FitmentsSortingPanelComponent,
    CellWidthDirective,
    FitmentsSearchPageComponent,
    DefaultResearchInfograficComponent,
    CellEditFormComponent,
  ],
  exports: [
    FitmentsAdvancedSearchComponent,
    FitmentListManagerComponent,
    FitmentsTableComponent,
    FitmentsSearchResultsComponent,
    FitmentsTextRendererComponent,
    FitmentsSortingPanelComponent,
    CellWidthDirective,
    FitmentsContextualActionModule,
    FitmentsSearchPageComponent,
    DefaultResearchInfograficComponent,
    CellEditFormComponent,
  ],
  providers: [
    FitmentsListService,
    FitmentsService,
    MyFitmentsSearchService,
  ]
})
export class FitmentsModule {}
